import { Router } from "@angular/router";
import { Injectable } from '@angular/core';
import * as $ from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

	constructor(
		public router: Router
	) { }

	addRouterLink(htmlElement:string, stopPropagation:boolean = false){
		let checker = setInterval(f => {
			let el = $(htmlElement);
			if(el.length){
				let a = this;
				el.on('click', function(e){
					let link = this.getAttribute('href');

					if(a.isValidURL(link)){
						window.location.href = link;
					}
					else {
						a.router.navigate([link]);
					}

					if(stopPropagation){
						e.stopPropagation();
					}
					e.preventDefault();
				});
				clearInterval(checker);
			}
		}, 1000);
	}

	isValidURL(str:string) {
		var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
		  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
		  '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
		  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
		  '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
		  '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
		return !!pattern.test(str);
	}
}
